var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('GenericDialog',{attrs:{"activator":_vm.activator},on:{"close":function($event){return _vm.emitClose()}}},[_c('v-card-title',[_vm._v(" Add new favourite location ")]),_c('FavLocationForm',{on:{"close":function($event){return _vm.emitClose()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }